import { render, staticRenderFns } from "./MsgEditor.vue?vue&type=template&id=00789911&scoped=true&"
import script from "./MsgEditor.vue?vue&type=script&lang=js&"
export * from "./MsgEditor.vue?vue&type=script&lang=js&"
import style0 from "./MsgEditor.vue?vue&type=style&index=0&id=00789911&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00789911",
  null
  
)

export default component.exports